import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EngineComponent } from './components/engine/engine.component';
import { NgxsModule } from '@ngxs/store';
import { EngineState } from './state/engine.state';
import { StoryModule } from '../story/story.module';
import { EngineCameraState } from './state/camera/engine.camera.state';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../material.module';
import { EngineCameraBarComponent } from './components/engine-camera-bar/engine-camera-bar.component';
import { EngineToolBarComponent } from './components/engine-tool-bar/engine-tool-bar.component';
import { EngineScrubberComponent } from './components/engine-scrubber/engine-scrubber.component';
import { FormsModule } from '@angular/forms';
import { EngineNodesState } from './state/nodes/engine.nodes.state';
import { EngineBreadcrumbComponent } from './components/engine-breadcrumb/engine-breadcrumb.component';
import { NodeActionsModule } from '../shared/components/node-actions/node-actions.module';
import { EngineProgressComponent } from './components/engine-progress/engine-progress.component';
import { EngineProgressState } from './state/progress/engine.progress.state';
import { DirectivesModule } from '../shared/directives/directives.module';
import { EngineScrollComponent } from './components/engine-scroll/engine-scroll.component';

@NgModule({
  imports: [
    NgxsModule.forFeature([
      EngineState,
      EngineCameraState,
      EngineNodesState,
      EngineProgressState
    ]),

    CommonModule,
    DirectivesModule,
    MaterialModule,
    FormsModule,
    StoryModule,
    SharedModule,
    NodeActionsModule
  ],
  declarations: [
    EngineComponent,
    EngineCameraBarComponent,
    EngineToolBarComponent,
    EngineScrubberComponent,
    EngineBreadcrumbComponent,
    EngineProgressComponent,
    EngineScrollComponent
  ],
  exports: [
    EngineComponent,
    EngineCameraBarComponent,
    EngineToolBarComponent,
    EngineScrubberComponent,
    EngineBreadcrumbComponent,
    EngineProgressComponent
  ]
})
export class EngineModule { }
